import env from "../../../env"
import setIfNotSet from "../../../setIfNotSet"
import {PRODUCTION} from "../../../constants/environment"
import type {APIRequestConfig} from "../../API"

export const VIVUP_OVERRIDE_HEADER = "x-pb-vivup"
export const VIVUP_PARTNER_ID_OVERRIDE_HEADER = "x-pb-vivup-partner-id"

export function appendVivupOverrideHeaders(config: APIRequestConfig): void {
  if (env.ENVIRONMENT_NAME === PRODUCTION) {
    return
  }

  const vivupUrl = env.VIVUP_URL.trim()
  const vivupPartnerId = env.VIVUP_PARTNER_ID.trim()

  if (vivupUrl !== "") {
    setIfNotSet(config, `headers.${VIVUP_OVERRIDE_HEADER}`, vivupUrl)
  }

  if (vivupPartnerId !== "") {
    setIfNotSet(config, `headers.${VIVUP_PARTNER_ID_OVERRIDE_HEADER}`, vivupPartnerId)
  }
}
